import api from "../../config/client.axios.api";

export const updatePaperMachineApi = async (infoUpdate: any) => {
  const response = await api.put(`/machine/printer-paper`, infoUpdate);
  return response.data;
};
